module.exports = __webpack_public_path__ + "static/media/mdi_transfer.c07cb3e3.svg";